import { get } from "../../utils/objectHelpers";

<if(input && input.tabsModule)>
    <div class="str-controlbar-wrap" key="str-controlbar-wrap">
        <div class="str-controlbar app-layout app-layout--gutters">
            <div class="str-controlbar__tabs">
                <str-tablist ...input.tabsModule />
            </div>
            <div class="str-controlbar__search">
                <str-search ...input.searchModule />
            </div>
        </div>
    </div>
</if>
